import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/about',
            name: 'about',
            component: () => import('./views/About.vue')
        },
        {
            path: '/wedo/showroom',
            name: 'showroom',
            redirect: '/',
            component: () => import('./views/ShowRoom.vue'),
            children: [
                {
                    path: ':id',
                    name: 'showroom id',
                    component: () => import('./views/ShowRoomDetail.vue')
                },
                {
                    path: ':id/:car',
                    name: 'showroom car',
                    component: () => import('./views/Car.vue'),
                },
            ]
        },
        {
            path: '/wedo/workshop',
            name: 'workshop',
            component: () => import('./views/WorkShop.vue'),
        },
        {
            path: '/wedo/class',
            name: 'class',
            component: () => import('./views/Class.vue'),
        },
        {
            path: '/wedo/production',
            name: 'production',
            component: () => import('./views/Production.vue'),
            children: [
                {
                    path: ':id',
                    name: 'bus & truck',
                    component: () => import('./views/ProductionDetail.vue')
                },
            ]
        },
        {
            path: '/news',
            name: 'news',
            component: () => import('./views/News.vue')
        },
        {
            path: '/news/:id',
            name: 'news detail',
            component: () => import('./views/NewsDetail.vue')
        },
        {
            path: '/contact',
            name: 'contact',
            component: () => import('./views/Contact.vue')
        },
        {
          path: '/search/:key',
          name: 'search',
          component: () => import('./views/Search.vue')
        },
    ]
})
